
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.667 4a.667.667 0 00-.617.413l-2.333 5.666a.667.667 0 00.616.921H8.75a.167.167 0 01.157.223l-2.867 7.88a.67.67 0 001.03.759l4.998-3.795a.166.166 0 01.2 0l5 3.8a.671.671 0 001.03-.757l-2.842-7.887a.167.167 0 01.157-.223h3.055a.667.667 0 00.616-.92L16.95 4.412A.667.667 0 0016.333 4H7.667zm5.585 3.703a.166.166 0 01.004-.223l.456-.487a.167.167 0 01.288.114v1.008a.167.167 0 01-.292.11l-.456-.522zm-.297 1.687a.167.167 0 01-.125.277h-1.24a.167.167 0 01-.121-.281l.641-.684a.166.166 0 01.247.005l.598.683zm-.559-2.943a.167.167 0 01-.247-.004l-.729-.833a.167.167 0 01.125-.277h1.51a.167.167 0 01.122.281l-.781.833zm-2.063.39a.167.167 0 01.292-.11l.629.719a.167.167 0 01-.004.223l-.629.671a.167.167 0 01-.288-.114V6.837zm4.134 5.582a.166.166 0 01-.056.189l-2.144 1.63a.166.166 0 01-.2 0L9.94 12.624a.165.165 0 01-.055-.189l.448-1.351a.082.082 0 01.083-.083h3.434c.08 0 .148.056.163.133l.454 1.286zM8.07 5.437a.167.167 0 01.154-.104h.608c.092 0 .167.075.167.167v4a.167.167 0 01-.167.167H6.577a.167.167 0 01-.154-.23l1.648-4zm.448 11.651a.167.167 0 01-.258-.19l1.027-2.823A.167.167 0 019.545 14l1.345 1.022a.167.167 0 010 .267l-2.371 1.799zm6.281-3.1a.167.167 0 01.258.075l1.024 2.846a.167.167 0 01-.257.189l-2.385-1.812a.167.167 0 010-.267l1.36-1.032zm.7-4.321a.167.167 0 01-.167-.167v-4c0-.092.075-.167.167-.167h.275c.068 0 .129.041.154.104l1.648 4a.167.167 0 01-.154.23H15.5z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    